import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../../view/components/ui/use-toast";
import { usersService } from "../services/usersService";
import { UpdateCpfBody } from "../services/usersService/updateCpf";

export const useUpdateCpf = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const {
    mutateAsync: updateCpfMutate,
    isError,
    isSuccess,
  } = useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateCpfBody }) =>
      usersService.updateCpf(id, body),
    onError: (e) => {
      toast({
        variant: "destructive",
        title:
          e?.message || "Erro ao atualizar o CPF. Tente novamente mais tarde.",
      });
    },
    onSuccess: (_, { id }) => {
      toast({
        variant: "default",
        title: "CPF atualizado com sucesso!",
      });

      queryClient.invalidateQueries({
        queryKey: ["sellerInfo", id],
      });
    },
  });

  return {
    updateCpf: updateCpfMutate,
    isError,
    isSuccess,
  };
};
